import React from "react";
import "./CustomerCard.scss";

const CustomerCard = ({ user, index, onCardClick }) => {
  // Logic to match initials and colors dynamically
  const getInitials = (name) => {
    if (!name) return "??";

    const parts = name.trim().split(/\s+/); // Split by any whitespace

    if (parts.length >= 2) {
      // Case: First and Last name exists
      return (parts[0][0] + parts[1][0]).toUpperCase();
    } else {
      // Case: Only one name exists (e.g., "rudra")
      // Return first two letters, or just one if it's a single-letter name
      return name.substring(0, 2).toUpperCase();
    }
  };

  // Color palette from your screenshot
  const colors = ["#66BB6A", "#9575CD", "#4DD0E1", "#AED581"];
  const bgColor = colors[index % colors.length];

  return (
    <div className="card-container" onClick={onCardClick}>
      <div className="avatar-box" style={{ backgroundColor: bgColor }}>
        {getInitials(user.username)}
      </div>

      <div className="content-box">
        <h3 className="user-name">{user.username}</h3>
        <div className="phone-row">
          <span className="phone-icon">📞</span>
          <span className="phone-number">{user.mobile}</span>
        </div>
      </div>
    </div>
  );
};

export default CustomerCard;
